import type { CheckoutSavedAddress } from '../addressBookAdapter'
import type { CheckoutAddressForm } from '../flow'

export const isEmptyCheckoutAddressForm = (form: CheckoutAddressForm) =>
  [form.firstName, form.lastName, form.line1, form.city, form.postalCode].every((value) => value.trim().length === 0)

export const hasRequiredCheckoutAddressFields = (form: CheckoutAddressForm) =>
  [
    form.firstName.trim(),
    form.lastName.trim(),
    form.line1.trim(),
    form.city.trim(),
    form.postalCode.trim(),
    form.country.trim(),
  ].every((value) => value.length > 0)

export const buildAddressFormSignature = (form: CheckoutAddressForm) =>
  [form.line1, form.city, form.postalCode, form.country].map((value) => value.trim().toLowerCase()).join('|')

export const buildEmptyDraftAddress = (form: CheckoutAddressForm): CheckoutAddressForm => ({
  firstName: form.firstName.trim(),
  lastName: form.lastName.trim(),
  company: '',
  line1: '',
  line2: '',
  city: '',
  postalCode: '',
  region: '',
  country: form.country.trim() || 'IT',
  phone: form.phone.trim(),
})

export const mergeCustomCheckoutAddresses = (
  base: CheckoutSavedAddress[],
  customAddresses: CheckoutSavedAddress[],
) => {
  if (customAddresses.length === 0) return base
  const customById = new Map(customAddresses.map((entry) => [entry.id, entry]))
  const merged = base.map((entry) => customById.get(entry.id) ?? entry)
  const mergedIds = new Set(merged.map((entry) => entry.id))
  const extras = customAddresses.filter((entry) => !mergedIds.has(entry.id))
  return [...merged, ...extras]
}
